<template>
    <DragPanel>
        <div class="detail-panel">
            <div class="item" v-for="(item,index) in infoData" :key="index">
                <span>{{item.key}}:</span><span>{{item.value}}</span>
            </div>
        </div>
    </DragPanel>
</template>

<script>
import DragPanel from './DragPanel'
export default {
    name: "DetailZone",
    components: { DragPanel },
    props: {
        itemData: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data() {
        return {
            infoData: []
        }
    },
    created() {
        this.getInfoAxios()
    },
    watch: {
        'itemData.lotNumber'() {
            this.getInfoAxios()
        }
    },
    methods: {
        handleClose() {
            this.$parent.clearSelectedTree()
        },
        //获取地块信息
        getInfoAxios() {
            let _this = this;
            let url = `${window.pubilc_config.digitalServerurl}/v1/digital/function_zone_info_card`
            this.$common.getTokenRequest()
            .get(url + '?lotNumber='+_this.itemData.lotNumber)
            .then(res => {
              if (res.status === 200) {
                let data = res.data;
                if(data.code === 0) {
                    _this.infoData = data.data;
                }
              }
            }).catch(err=>{
              console.log(err,'===/v1/digital/function_zone_info_card')
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.detail-panel {
    width: 100%;
    display: flex;
    flex-direction: column;
    .item {
        width: 100%;
        height: 30px;
        font-size: 14px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>